module.exports = __webpack_public_path__ + "static/qxc-2e0743bb37668405e42f0c11bc866466.png";